module.exports = __webpack_public_path__ + "img/42d6a63.png";